export default {
    // ---------Title--------
    adminProfile: '后台管理员档案',
    customerProfile: '客户档案',
    fullDetailsOfCustomerInformation: '客户完整详细信息',
    markingInfo: '唛头信息',
    detailsOfMarkingInformation: '唛头详细信息',
    mainBranchProfile: '分行档案',
    mainBranchProfileDetailsInformation: '分行档案的详细信息',
    mainBranchAddress: '分行地址',
    mainBranchAddressDetailsInformation: '分行地址的详细信息',
    branches: '分行',
    branchProfile: '分行档案',
    branchDetailsInformation: '分行详细信息',
    branchUsers: '分行用户',
    branchUserDetailsInformation: '分行用户详细信息',
    branchAddress: '分行地址',
    branchAddressDetailsInformation: '分行地址详细信息',
    accessScopes: '权限范围',
    accessPermissionOfScopes: '访问权限范围',
    supplierProfile: '供应商档案',
    fullDetailsOfSupplierInformation: '供应商详细信息',
    address: '地址',
    fullAddressDetailsOfSupplierInformation: '供应商完整地址详细信息',
    bankInfo: '银行信息',
    supplierBankDetails: '供应商银行详细资料',
    driverProfile: '运送司机档案',
    fullDetailsOfDriverInformation: '运送司机详细信息',
    workerProfile: '仓库员工',
    fullDetailsOfWorkerInformation: '仓库员工详细信息',
    person: '个人信息',
    detailsOfPersonInformation: '个人信息详情',
    detailsOfCompanyInformation: '公司信息详情',
    mainOutletInfo: '主要门店信息',
    fullDetailsOfOutletInformation: '门店完整详细信息',
    mainOutletAddress: '主要门店地址',
    fullOutletAddressDetailsInformation: '门店地址',
    retailerProfile: '零售商档案',
    fullDetailsOfRetailerInformation: '零售商完整详细信息',
    listOfOutletsInformation: '门店信息列表',
    outletUsers: '店员',
    assignedUsersInformation: '分配用户信息',
    viewAdministrator: '预览后台管理',
    viewCustomer: '预览客户',
    viewSupplier: '预览供应商',
    viewRetailer: '预览零售',
    viewDriver: '预览派送员',
    viewMember: '预览会员',
    viewWorker: '预览仓库员',
    editProfile: '编辑资料',
    administratorProfileDetails: '后台管理资料详情',
    customerProfileDetails: '客户资料详情',
    supplierProfileDetails: '供应商资料详情',
    retailProfileDetails: '零售资料详情',
    driverProfileDetails: '派送员资料详情',
    memberProfileDetails: '会员资料详情',
    workerProfileDetails: '仓库员资料详情',
    thereIsNoBranchAddedAtTheMoment: '目前尚未添加分行!',
    thereIsNoBranchUserBeenAssignedAtTheMoment: '目前尚未分配分行用户!',
    thereIsNoOutletAddedAtTheMoment: '目前尚未添加门店!',
    thereIsNoOutletUserBeenAssignedAtTheMoment: '目前尚未分配门店店员!',
    outletDetailsInformation: '门店详细信息',
    outletUserDetailsInformation: '门店用户详细信息',
    zones: '区域',
    zoneAllocationArea: '区域分配区',
    thereIsNoZoneBeenAssignedAtTheMoment: '目前尚未分配区域!',
    zone: '区域',
    rack: '货架',

    // ----------MUI----------
    customerCode: '客户编码',
    regNo: '注册号',
    registrationNo: '注册号',
    accountCode: '账户编码',
    salesperson: '销售员',
    branchName: '分行名称',
    branchCode: '分行编码',
    branchContact: '分行联系号码',
    branchEmail: '分行邮件',
    contactName: '联系人名称',
    contactNo: '联系人号码',
    contactEmail: '联系人邮件',
    branchMarking: '分行唛头',
    branchType: '分行类型',
    hq: '总部',
    mainHQ: '主总部',
    normal: '分行',
    addMarking: '添加唛头',
    createNew: '添加',
    new: '添加',
    bankName: '银行名称',
    bankAccount: '银行账号',
    users: '用户',
    user: '用户',
    code: '编码',
    members: '会员',
    outlets: '门店',
    outlet: '门店',
    business: '企业',
    differentBusiness: '不同企业',
    sameBusiness: '相同企业',
    outletName: '门店名称',
    outletCode: '门店编码',
    outletContact: '门店联系',
    outletEmail: '门店邮件',
    outletType: '门店种类',

    primaryRegistrationNo: '主要登记号',
    secondaryRegistrationNo: '次要登记号',
    taxation: '税收',
    detailsOfTaxationInformation: '税务信息详情',
    taxIdentificationNo: '税务识别号',
    taxRegistrationNo: '税务登记号',
    excludeTax: '排除税款',

    // ---------Drawer--------
    newBranch: '添加分行',
    updateBranch: '更新分行',
    newBranchUser: '添加分行用户',
    updateBranchUser: '更新分行用户',
    mainBranch: '主分行',
    normalBranch: '普通分行',
    shippingAddress: '送货地址',
    newOutlet: '添加门店',
    newOutletUser: '添加店员',
    updateOutlet: '更新门店',
    updateOutletUser: '更新店员',

    outletInfo: '门店信心',
    mainOutlet: '主要门店',
    normalOutlet: '普通门店',
    outletAddress: '门店地址',

    youHaveNotCreatedAnyItemYet: '目前还未添加任何项目.',
};